import { pr, theme, ui } from "aaa";
import { Card } from "components/common/georgeComponents";
import * as React from "react";

export const SigningJuniorCard = ({ childName }: { childName: string }) => {
    return (
        <Card
            elevated={false}
            style={{
                borderRadius: theme.BORDER_RADIUS_LARGE,
                padding: theme.MARGIN,
                marginTop: theme.MARGIN,
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
            }}
        >
            <pr.P_12_CONTENT style={{
                marginBottom: 4,
            }}>
                {ui.__("gJunior.activate.signing.action.label")}
            </pr.P_12_CONTENT>
            <pr.P_16_TITLE style={{
                lineHeight: "22px",
                marginBottom: 12,
                fontWeight: 600,
            }}>
                {ui.__("gJunior.activate.signing.action.text")}
            </pr.P_16_TITLE>

            <pr.P_12_CONTENT style={{
                lineHeight: "16px",
                marginBottom: 4,
            }}>
                {ui.__("gJunior.activate.signing.name.label")}
            </pr.P_12_CONTENT>
            <pr.P_16_TITLE style={{
                lineHeight: "22px",
                fontWeight: 600
            }}>
                {childName}
            </pr.P_16_TITLE>
        </Card>
    );
};


// WEBPACK FOOTER //
// ./src/components/gJunior/components/cards/SigningJuniorCard.tsx